import { ApiQuery } from '../shared/apiQuery';

import type {
  CampaignDetails,
  CampaignDetailsResponse,
} from './tripsApi.model';
import { mapResponseToCampaignDetails } from './tripsApi.helpers';

export class TripsApi {
  private query: ApiQuery;
  private readonly baseUrl = 'https://trips-api.sembo.com/v1/';
  public constructor() {
    this.query = new ApiQuery(this.baseUrl);
  }

  public async fetchCampaignDetails(
    campaignId: string,
    market: string
  ): Promise<CampaignDetails | undefined> {
    const response = await this.query.get<CampaignDetailsResponse>(
      `/${market}/campaigns/${campaignId}`
    );

    return mapResponseToCampaignDetails(response);
  }
}
